module.exports = __webpack_public_path__ + "static/media/Copper Queen.d1335218.jpg";